import { IconProps, Icon } from "@chakra-ui/react";

export const PlugIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.1875 0C8.87684 0 8.625 0.251839 8.625 0.562499V4.18183H4.5H3V5.68183V11.8529C3 15.2104 5.53075 18.0641 9.05505 19.1038C9.01893 19.2398 9 19.3802 9 19.5239C9 20.4598 9.8029 21.2586 10.9329 21.5729C10.8954 21.678 10.875 21.7911 10.875 21.9091V22C10.875 22.5523 11.3227 23 11.875 23H12.125C12.6773 23 13.125 22.5523 13.125 22V21.9091C13.125 21.7911 13.1046 21.678 13.0671 21.5729C14.1971 21.2586 15 20.4598 15 19.5239C15 19.3802 14.9811 19.2398 14.9449 19.1038C18.4693 18.0641 21 15.2104 21 11.8529V5.68183V4.18183H19.5H15.375V0.5625C15.375 0.25184 15.1232 0 14.8125 0C14.5018 0 14.25 0.251839 14.25 0.562499V4.18183H12H9.75V0.5625C9.75 0.25184 9.49816 0 9.1875 0ZM4.5 11.8529V5.68183H12H19.5V11.8529C19.5 14.3963 17.5625 16.7677 14.5205 17.6651L13.1204 18.0781L13.4952 19.489C13.4987 19.5019 13.5 19.513 13.5 19.5239C13.5 19.534 13.4975 19.6718 13.2365 19.8625C12.9766 20.0523 12.5443 20.2156 12 20.2156C11.4557 20.2156 11.0234 20.0523 10.7635 19.8625C10.5025 19.6718 10.5 19.534 10.5 19.5239C10.5 19.513 10.5013 19.5019 10.5048 19.489L10.8796 18.0781L9.47948 17.6651C6.4375 16.7677 4.5 14.3963 4.5 11.8529Z"
        fill="black"
      />
      <ellipse
        cx="9.1875"
        cy="9.93182"
        rx="0.5625"
        ry="0.522727"
        fill="#18181B"
      />
      <ellipse
        cx="14.8125"
        cy="9.93182"
        rx="0.5625"
        ry="0.522727"
        fill="#18181B"
      />
    </Icon>
  );
};

export const StoicIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon fill="none" viewBox="0 0 24 24" {...props}>
      <path
        d="M2.96774 2C3.6129 2 21.0323 2 21.0323 2M2.96774 2C2.32258 2 2 2.29412 2 2.88235M2.96774 2H21.0323M21.0323 2C21.7749 2.04729 21.9766 2.25247 22 2.88235V13C22 13 14.2457 8.33929 13 7.6C11.7543 6.86071 10.8 8.1895 12 9C13.2157 9.73 22 15 22 15V16.7059L12.3226 22L2 16.7059V10.5294L11.1935 15.9706C12.3182 16.5098 13.0118 15.0538 12 14.5L2 8.5M2 8.5C2 8.5 2 3.47059 2 2.88235M2 8.5V2.88235"
        stroke="black"
        strokeWidth="1.5"
      />
    </Icon>
  );
};

export const DfinityIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 52 24" {...props}>
      <g clipPath="url(#clip0_268_2356)">
        <path
          d="M38.625 0C35.8335 0 32.7883 1.44274 29.574 4.28777C28.0511 5.62766 26.719 7.0704 25.7461 8.22514C25.7461 8.22514 27.3108 9.936 29.024 11.7703C29.9544 10.6574 31.2865 9.15292 32.83 7.79246C35.6851 5.25669 37.546 4.74103 38.625 4.74103C42.6424 4.74103 45.8991 7.93646 45.8991 11.8944C45.8991 15.8112 42.6424 19.0066 38.625 19.0478C38.4341 19.0478 38.2014 19.0272 37.9271 18.9655C39.0902 19.4798 40.3586 19.8514 41.543 19.8514C48.9019 19.8514 50.34 15.0274 50.4249 14.677C50.6363 13.7911 50.7629 12.8633 50.7629 11.915C50.7423 5.33897 45.3073 0 38.625 0Z"
          fill="url(#paint0_linear_268_2356)"
        />
        <path
          d="M41.5225 19.6869C37.7582 19.584 33.8461 16.5943 33.0422 15.8524C30.9699 13.9351 29.0241 11.7504 29.0241 11.7504C27.3116 9.91545 25.7462 8.20459 25.7462 8.20459C25.1968 8.84368 22.4902 11.8732 22.4902 11.8732C22.4902 11.8732 24.3088 13.7705 24.4565 13.9351C28.0094 18.1406 33.3597 23.7477 38.6463 23.7477C44.3557 23.7271 49.1565 19.8309 50.4257 14.6153C50.3196 14.9863 48.4163 19.872 41.5225 19.6869Z"
          fill="#F1F36E"
        />
        <path
          d="M12.9325 23.7684C15.724 23.7684 18.7692 22.3257 21.9827 19.4806C23.5057 18.1408 24.8378 16.698 25.8107 15.5433C25.8107 15.5433 24.246 13.8324 22.5328 11.9981C21.6024 13.111 20.2703 14.6155 18.7268 15.976C15.8717 18.4912 13.9896 19.0274 12.9325 19.0274C8.91439 19.0274 5.65773 15.832 5.65773 11.874C5.65773 7.95722 8.91439 4.76179 12.9325 4.72065C13.1227 4.72065 13.3554 4.74122 13.6304 4.80294C12.4673 4.28796 11.1982 3.91699 10.0138 3.91699C2.65489 3.91699 1.21676 8.74031 1.13262 9.09139C0.912097 9.99664 0.798474 10.9233 0.793945 11.8534C0.793945 18.4294 6.22902 23.7684 12.9325 23.7684Z"
          fill="url(#paint1_linear_268_2356)"
        />
        <path
          d="M10.0138 4.01966C13.7774 4.12251 17.7107 7.15337 18.5146 7.89532C20.587 9.81257 22.5328 11.9973 22.5328 11.9973C23.6309 13.1744 24.7235 14.3564 25.8106 15.5431C26.36 14.904 29.0666 11.8738 29.0666 11.8738C29.0666 11.8738 27.2481 9.97714 27.1003 9.81257C23.5686 5.60709 18.2184 0 12.9318 0C7.22235 0.0205714 2.42149 3.9168 1.15234 9.13234C1.21598 8.78194 3.09814 3.85509 10.0138 4.01966Z"
          fill="#F1F36E"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_268_2356"
          x1="32.258"
          y1="1.72114"
          x2="48.5267"
          y2="19.003"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#E65031" />
          <stop offset="0.684" stopColor="#FBF670" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_268_2356"
          x1="19.2847"
          y1="22.0384"
          x2="3.01663"
          y2="4.75656"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#E65031" />
          <stop offset="0.893" stopColor="#FBF670" />
        </linearGradient>
        <clipPath id="clip0_268_2356">
          <rect width="51.2" height="24" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
};
